export default __webpack_public_path__ + "static/media/dresser003.83af6364.jpeg";